/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { getAddOns } from 'state/actions/commentingState/addOnsStatus';
// material
import CommentsCounterSection from 'pages/dashboard/commenting/addons/commentscountersection/commentscountersection';
import CommunitySection from 'pages/dashboard/commenting/addons/communitysection/communitysection';
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/addons/addons_styles';


/* ========== ~~~~~~~~~~ ADDONS PAGE ~~~~~~~~~~ ========== */
const AddOns = (props) => {

    const commentingStatus = useSelector(state => state.commentingState.commentingStatus);
    const siteUUID = commentingStatus.selectedSite ? commentingStatus.selectedSite.value : null;
    const dispatch = useDispatch();

    useEffect(() => {
        if(siteUUID)
            dispatch(getAddOns(siteUUID))
    },[]);

    return(
        <div className={`addons ${props.classes.addons}`}>
            <CommentsCounterSection />
            <CommunitySection />
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddOns);
